import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App.tsx';
import './index.css';
import './i18n/config';
import i18n from './i18n/config';
import { useCurrencyStore } from './stores/currencyStore';

// Initialize currency based on current language
const currentLang = i18n.language;
const storedCurrency = localStorage.getItem('broiler-currency-storage');

if (!storedCurrency) {
  const { setCurrency } = useCurrencyStore.getState();
  if (currentLang === 'tr') {
    setCurrency('TRY');
  } else if (currentLang === 'en') {
    setCurrency('USD');
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>,
);
